<template>
  <v-container>
    <v-row style="margin-top: 10px">
      <v-col cols="12">
        <v-card class="my-0" :flat="$vuetify.breakpoint.smAndDown">
          <v-card-title class="profileContainer text-center">
            <v-btn color="primary" @click="dialogQR = true" dark icon x-large min-width="0"
              style="position: absolute; top: 0px; left: 0px;">
              <v-icon>mdi-qrcode</v-icon>
            </v-btn>
            <div class="v-avatar mx-auto v-card--material--avatar">
              <croppa v-model="croppa" :disabled="!showEditButtons" :initial-image="cardUserImage"
                :prevent-white-space="true" :width="130" :height="130" :placeholder="$t('drag_here')"
                placeholder-color="#999999" :placeholder-font-size="14" canvas-color="transparent"
                :show-remove-button="true" remove-button-color="black" :show-loading="true" :loading-size="50"
                @init="onInit" />
            </div>

            <v-container class="buttonAvatar">
              <v-btn color="primary" @click="showEditButtons = !showEditButtons" dark icon min-width="0">
                <v-icon>{{ showEditButtons ? "mdi-close" : "mdi-pencil" }}</v-icon>
              </v-btn>

              <template v-if="showEditButtons">
                <v-btn color="primary" @click="croppa.chooseFile()" dark icon min-width="0">
                  <v-icon>mdi-cloud-upload</v-icon>
                </v-btn>

                <v-btn color="red" @click="croppa.remove()" dark icon min-width="0">
                  <v-icon>mdi-delete-forever</v-icon>
                </v-btn>

                <v-btn color="secondary" @click="rotateLeft" dark icon min-width="0">
                  <v-icon>mdi-rotate-left</v-icon>
                </v-btn>

                <v-btn color="secondary" @click="rotateRight" dark icon min-width="0">
                  <v-icon>mdi-rotate-right</v-icon>
                </v-btn>

                <v-btn color="secondary" @click="flipHorizontal" dark icon min-width="0">
                  <v-icon>mdi-flip-horizontal</v-icon>
                </v-btn>

                <v-btn color="secondary" @click="flipVertical" dark icon min-width="0">
                  <v-icon>mdi-flip-vertical</v-icon>
                </v-btn>

                <v-btn color="success" @click="saveAvatar()" dark icon min-width="0">
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
              </template>
            </v-container>
          </v-card-title>
          <v-card-text>
            <div class="text-center">
              <h4 class="display-2 font-weight-light mb-3">{{ fullName }}</h4>
              <h6 class="display-1 mb-1 grey--text">
                {{ $t(publicRole).toUpperCase() }}
              </h6>
            </div>
            <v-simple-table>
              <tbody>
                <tr>
                  <td>{{ $t("point") }}</td>
                  <td>{{ saldoPunti }}</td>

                  <td>{{ $t("events_coming") }}</td>
                  <td>{{ eventiInArrivo }}</td>

                  <td>{{ $t("account_balance") }}</td>
                  <td>{{ saldoCge }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
          <div class="qr-code">

          </div>
        </v-card>

        <v-card :flat="$vuetify.breakpoint.smAndDown">
          <v-card-text style="padding: 0px;">
            <v-carousel v-if="tessereOwned && tessereOwned.length > 0" v-model="slideTessera"
              :show-arrows="tessereOwned.length > 1" hide-delimiters light height="auto">
              <template v-slot:prev="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" fab dark small color="primary">
                  <v-icon dark>
                    mdi-chevron-left
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:next="{ on, attrs }">
                <v-btn fab dark small color="primary" v-bind="attrs" v-on="on">
                  <v-icon dark>
                    mdi-chevron-right
                  </v-icon>
                </v-btn>
              </template>
              <v-carousel-item v-for="tessera in tessereOwned" :key="tessera.full_key">

                <v-card-title>
                  <div class="display-2 font-weight-light col col-12 text-left text--primary pa-0">
                    <h5 class="font-weight-light text-center">
                      {{ tessera.asdRagSoc }}
                      <br>
                      <span class="subtitle-1" v-text="season" />
                    </h5>
                  </div>

                </v-card-title>
                <v-card-text>
                  <div class="text-center tessera-container">
                    <img class="img" :src="tessera.image" style="max-height: 150px; width: auto" />
                  </div>

                  <div class="text-center tessera-container" v-if="tessera.havePdf || tessera.haveDiplomaPdf">
                    <br />
                    <v-btn v-if="tessera.havePdf" class="mx-5" @click="downloadTessera(tessera.tesseraUrl)"
                      color="success">
                      <v-icon>mdi-card-account-details-outline</v-icon><span style="margin-left: 5px">{{ $t("card") }}
                      </span>
                    </v-btn>
                    <v-btn v-if="tessera.haveDiplomaPdf" class="mx-5" @click="downloadTessera(tessera.diplomaUrl)"
                      color="success">
                      <v-icon>mdi-certificate-outline</v-icon><span style="margin-left: 5px">{{ $t("diploma") }}</span>
                    </v-btn>
                    <br /><br />
                  </div>
                  <v-simple-table>
                    <tbody>

                      <tr>
                        <td>{{ $t("type_affiliation_card") }}</td>
                        <td>
                          {{ tessera.nome }}
                          {{
                            tessera.numero
                            ? " - " + tessera.numero
                            : " - " + $t("waiting_approval")
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("date_affiliation") }}</td>
                        <td>
                          {{ new Date(tessera.dateTes).toLocaleDateString() }}
                        </td>
                      </tr>
                      <tr>
                        <td>{{ $t("expire_date") }}</td>
                        <td>
                          {{ new Date(tessera.dateEnd).toLocaleDateString() }}
                        </td>
                      </tr>
                      <tr v-if="tessera.supervisor">
                        <td>{{ $t("supervisor") }}</td>
                        <td>{{ tessera.supervisor }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-card-text>

              </v-carousel-item>
            </v-carousel>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogQR" width="500" height="500">
      <img class="img" style="height: 100%" :src="userQR" />
    </v-dialog>
  </v-container>
</template>
<script>
export default {
  name: "user-card",
  props: {
    masterId: null,
  },
  data() {
    return {
      cardUserImage: "",
      publicRole: "",
      fullName: "",
      id: null,
      dialogQR: false,
      saldoPunti: null,
      eventiInArrivo: null,
      saldoCge: null,
      userQR: null,
      ifTessera: false,
      tesseraAttiva: null,
      tessereOwned: [],
      imgTessera: "",
      asdTesNum: null,
      asdRagSoc: null,
      tesseraDex: null,
      supervisor: null,
      tesseraData: null,
      tesseraEnte: null,
      season: null,
      croppa: {},
      slideTessera: 0,
      showEditButtons: false,
    };
  },
  computed: {
    verifyChangeAvatar() {
      return this.$changeAvatar.changeAvatarRsp.updated;
    },
  },
  watch: {
    verifyChangeAvatar: function (changed) {
      this.fullName = window.myData.user;
    },
  },
  methods: {
    withCacheBuster(url) {
      if (!url) return url;
      const sep = url.indexOf("?") === -1 ? "?" : "&";
      return url + sep + "v=" + Date.now();
    },
    tesseraTabStyle(tessera) {
      return tessera.image
        ? "background-size: cover; background-image: linear-gradient(rgba(255,255,255,0.5), rgba(255,255,255,0.5)), url('" +
        tessera.image +
        "')"
        : "";
    },
    downloadTessera(tesseraUrl) {
      this.$documentViewer.documentViewerRsp.docUrl = tesseraUrl;
    },
    loadData() {
      let _ = this;
      let url = "/auth/portal/getUserData/";
      if (_.masterId) url += _.masterId;
      _.ifTessera = false;
      _.slideTessera = 0;
      // Info utente
      this.chiamataAxios("GET", url).then((response) => {
        let data = response.data;
        _.id = data.user.id;
        _.season = _.$t("season").toUpperCase() + " " + data.esercizio.season;
        _.cardUserImage = _.withCacheBuster(data.user.foto);
        _.publicRole = data.user.publicRole;
        _.fullName = data.user.fullName;
        _.saldoPunti = data.saldoPunti;
        _.eventiInArrivo = data.eventiInArrivo;
        _.saldoCge = data.saldoCge;
        _.ifTessera = data.tesseraAttiva ? true : false;
        _.tesseraAttiva = data.tesseraAttiva;
        _.imgTessera = data.tesseraAttiva.tesseraImage;
        _.asdRagSoc = data.tesseraAttiva.asdRagSoc;
        _.tessereOwned = data.tessereOwned.filter((tes) => {
          return (
            new Date(tes.dateInz) <= new Date() &&
            new Date(tes.dateEnd) >= new Date()
          );
        });
        _.tesseraDex = data.tesseraAttiva.nome;
        _.asdTesNum = data.tesseraAttiva.asdTesNum;
        if (data.tesseraAttiva && data.tesseraAttiva.supervisor)
          _.supervisor = data.tesseraAttiva.supervisor.fullName;
        _.tesseraData = new Date(
          data.tesseraAttiva.dateTes
        ).toLocaleDateString();
        _.tesseraEnte = data.tesseraAttiva.tesseraEnte;
        _.userQR = _.authorizeLink(data.userQR);
        _.croppa.refresh();
      });
    },
    getColorButton: function (buttonColor) {
      return "md-" + buttonColor + "";
    },
    saveAvatar() {
      let _ = this;
      let url = "/auth/portal/setAvatar";
      if (_.masterId) url += "/" + _.masterId;
      let dataUrl = this.croppa.generateDataUrl("image/png", 0.8);
      this.chiamataAxios("POST", url, {
        body: { imgData: dataUrl, mode: "clean" },
        msg: "always",
      }).then((response) => {
        _.cardUserImage = dataUrl;
        _.croppa.refresh();
        _.$changeAvatar.changeAvatarRsp.updated = new Date();
      });
    },
    uploadCroppedImage() {
      this.croppa.generateBlob(
        (blob) => {
          // write code to upload the cropped image file (a file is a blob)
        },
        "image/jpeg",
        0.8
      ); // 80% compressed jpeg file
    },
    rotateLeft() {
      if (
        this.croppa &&
        this.croppa.rotate &&
        typeof this.croppa.rotate === "function"
      ) {
        this.croppa.rotate(-1);
      }
    },
    rotateRight() {
      if (
        this.croppa &&
        this.croppa.rotate &&
        typeof this.croppa.rotate === "function"
      ) {
        this.croppa.rotate(1);
      }
    },
    flipHorizontal() {
      if (
        this.croppa &&
        this.croppa.flipX &&
        typeof this.croppa.flipX === "function"
      ) {
        this.croppa.flipX();
      }
    },
    flipVertical() {
      if (
        this.croppa &&
        this.croppa.flipY &&
        typeof this.croppa.flipY === "function"
      ) {
        this.croppa.flipY();
      }
    },
    onInit() {
      this.croppa.addClipPlugin(function (ctx, x, y, w, h) {
        /*
         * ctx: canvas context
         * x: start point (top-left corner) x coordination
         * y: start point (top-left corner) y coordination
         * w: croppa width
         * h: croppa height
         */
        ctx.beginPath();
        ctx.arc(x + w / 2, y + h / 2, w / 2, 0, 2 * Math.PI, true);
        ctx.closePath();
      });
    },
  },
  mounted() {
    this.loadData();
  },
  watch: {
    masterId: function (newVal, oldVal) {
      this.loadData();
    },
  },
};
</script>
<style lang="scss" scoped>
.profileContainer {
  margin-top: 18px !important;
}

.qr-code {
  width: 100% !important;
  text-align: center !important;
  top: 0px !important;
  position: absolute !important;
  right: 0px !important;
  height: 150px !important;
  width: 150px !important;

  img {
    width: auto !important;
    height: auto !important;
    max-height: 200px !important;
  }
}

.md-card-header-text {
  text-align: center;
  padding: 10px !important;
  font-size: 18px !important;
}

.tessera-container {
  text-align: center;
}

.croppa-container {
  background-color: transparent !important;
  border: 0px !important;
  border-radius: 130px !important;
  width: 130px !important;
  height: 130px !important;
}

.croppa-container canvas {
  border-radius: 130px !important;
}

.buttonAvatar {
  padding: 0px !important;
  margin-top: -30px !important;
  position: relative !important;
  z-index: 2 !important;
}
</style>
